(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apgo-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeGallery = (root) => {
      if (!root || root.dataset.apgoGalleryReady === 'true') return;

      root.dataset.apgoGalleryReady = 'true';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      root.querySelectorAll('[data-apgo-gallery-rail-shell]').forEach((shell) => {
        const rail = shell.querySelector('[data-apgo-gallery-rail]');
        const railPrevious = shell.querySelector('[data-apgo-gallery-rail-previous]');
        const railNext = shell.querySelector('[data-apgo-gallery-rail-next]');
        if (!rail) return;

        let frame = 0;
        const updateRailButtons = () => {
          frame = 0;
          const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
          if (railPrevious) railPrevious.disabled = rail.scrollLeft <= 2;
          if (railNext) railNext.disabled = rail.scrollLeft >= maxScroll - 2;
        };

        const scrollRail = (direction) => {
          rail.scrollBy({
            left: direction * rail.clientWidth * 0.82,
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        };

        rail.addEventListener('scroll', () => {
          if (!frame) frame = window.requestAnimationFrame(updateRailButtons);
        }, { passive: true });

        if (railPrevious) railPrevious.addEventListener('click', () => scrollRail(-1));
        if (railNext) railNext.addEventListener('click', () => scrollRail(1));
        updateRailButtons();
      });
    };

    const initializeAllGalleries = (scope = document) => {
      scope.querySelectorAll('[data-apgo-gallery]').forEach(initializeGallery);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAllGalleries());
    } else {
      initializeAllGalleries();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllGalleries(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest('[data-apgo-gallery]');
      if (!root) return;
      const card = root.querySelector(`[data-gallery-block-id="${event.detail.blockId}"]`);
      const rail = card ? card.closest('[data-apgo-gallery-rail]') : null;
      if (card && rail) {
        rail.scrollTo({ left: card.offsetLeft - rail.offsetLeft - 12, behavior: 'smooth' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-totals"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const wrapper = document.querySelector('[data-section-type="cart-totals"]');
    if (!wrapper) return;

    // 防止重複初始化
    const FLAG = wrapper.dataset.initFlag;
    if (window[FLAG]) return;
    window[FLAG] = true;

    const sid = wrapper.dataset.sectionId;
    const contentId = wrapper.dataset.contentId;

    // 小工具：每次都取最新的 content 容器
    const getContentEl = () => document.getElementById(contentId);

    // 去抖：把頻繁的事件合併
    let tmr;
    const debounce = (fn, delay = 180) => {
      clearTimeout(tmr);
      tmr = setTimeout(fn, delay);
    };

    // 用 routes.root 支援多語系/子路徑
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    function htmlToNode(html) {
      const dom = new DOMParser().parseFromString(html, 'text/html');
      return dom.getElementById(contentId);
    }

    // 關鍵：每次都加 cache-buster + no-store。否則 /cart?sections=<id> 是固定
    // URL，瀏覽器會把第一次的回應快取起來，數量改變後 AJAX 仍拿到舊 HTML
    //（就是「必須硬刷新才更新」的根因）。/cart.js（免運條用的）本來就 no-cache
    // 所以一直是對的，但這個 section render 端點沒有，會被快取。
    const NO_STORE = { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' };

    function refreshTotals() {
      // 先試新版 ?sections=
      const u1 = new URL(window.location.href);
      u1.pathname = root.replace(/\/$/, '') + u1.pathname.replace(root.replace(/\/$/, ''), '');
      u1.searchParams.set('sections', sid);
      u1.searchParams.set('_', Date.now());

      fetch(u1.toString(), NO_STORE)
        .then(r => r.ok ? r.json() : Promise.reject())
        .then(json => {
          const html = json && json[sid];
          if (!html) throw new Error('Sections JSON missing');
          const freshContent = htmlToNode(html);
          const contentEl = getContentEl();
          if (freshContent && contentEl) {
            contentEl.replaceWith(freshContent);
          }
        })
        .catch(() => {
          // 舊法 fallback: ?section_id=
          const u2 = new URL(window.location.href);
          u2.pathname = root.replace(/\/$/, '') + u2.pathname.replace(root.replace(/\/$/, ''), '');
          u2.searchParams.set('section_id', sid);
          u2.searchParams.set('_', Date.now());

          fetch(u2.toString(), NO_STORE)
            .then(r => r.text())
            .then(html => {
              const freshContent = htmlToNode(html);
              const contentEl = getContentEl();
              if (freshContent && contentEl) {
                contentEl.replaceWith(freshContent);
              }
            })
            .catch(() => {
              console.error('Failed to refresh totals');
            });
        });
    }

    // —— 核心：直接從 /cart.js 改寫顯示金額 ——
    // 這是免運條（apgo-coating-products）一直正確的原因：它不靠 section 重渲染，
    // 直接讀 /cart.js（永遠新鮮）自己畫數字。cart-totals 之前靠 ?sections= 重抓
    // HTML，那條路脆弱（被快取、跟 Horizon 搶、自己觸發自己），所以小計卡住。
    // 現在 cart-totals 也改成直接從 /cart.js 改寫，section 重渲染只負責折扣明細列。

    // 市場別貨幣符號（SGD → $、MYR → RM），與 apgo-coating-products 一致。
    // 新加坡一律用 $（跟 Liquid money 印的一樣，不用 S$）；符號後不空格：全站 RM36.90 / $36.90。
    function fmtMoney(minor, currency) {
      const amount = (Number(minor) || 0) / 100;
      const fixed = amount.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (currency === 'MYR') return `RM${fixed}`;
      if (currency === 'SGD') return `$${fixed}`;
      try {
        return new Intl.NumberFormat('en', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(amount);
      } catch (_) {
        return `${currency} ${fixed}`;
      }
    }

    // Weight tier price, same tiers as the Liquid estimate
    // (snippets/apgo-shipping-estimate.liquid → window.APGO_SHIPPING_TIERS).
    function tierPriceMinor(ccy, grams) {
      const tiers = (window.APGO_SHIPPING_TIERS || {})[ccy] || '';
      let price = 0;
      for (const tier of tiers.split(',')) {
        if (!tier) continue;
        const [below, minor] = tier.split(':').map(Number);
        price = minor;
        if (grams < below) break;
      }
      return price;
    }

    // Shipping estimate by cart weight — must mirror Liquid SSR + sections/cart-cta.liquid
    function shippingEstimateMinor(cart) {
      if (!cart || !cart.item_count) return 0;
      // Tag-unlock (a 'free-shipping' product, or a full set of the
      // bundle set offer) zeroes shipping regardless of subtotal.
      if (window.apgoFreeShippingTitle && window.apgoFreeShippingTitle(cart)) return 0;
      const ccy = cart.currency;
      const basis = (typeof window.apgoCartFreeShippingBasis === 'function')
        ? window.apgoCartFreeShippingBasis(cart)
        : Number(cart.total_price || 0);
      const grams = Number(cart.total_weight || 0);
      if (ccy === 'MYR') return basis >= 15500 ? 0 : tierPriceMinor(ccy, grams);
      if (ccy === 'SGD') return basis >= 7000 ? 0 : tierPriceMinor(ccy, grams);
      return 0;
    }
    // Exposed so cart-cta sticky bar can compute the same estimated total.
    window.apgoEstimatedShippingMinor = shippingEstimateMinor;

    function patchFromCart(cart) {
      if (!cart) return;
      const ccy = cart.currency;
      const ship = shippingEstimateMinor(cart);
      const estimatedTotal = Number(cart.total_price || 0) + ship;

      const subEl = document.querySelector('#' + contentId + ' .cart__original-total .cart__value');
      const totEl = document.querySelector('#' + contentId + ' [data-cart-subtotal]');
      if (subEl) subEl.textContent = fmtMoney(cart.original_total_price, ccy);
      if (totEl) {
        const t = fmtMoney(estimatedTotal, ccy);
        totEl.textContent = t;
        totEl.setAttribute('value', t);
      }

      // Mobile accordion fast-patch (full re-render arrives via ?sections= later).
      const mobileSub = document.querySelector('#' + contentId + ' [data-summary-subtotal]');
      const mobileDis = document.querySelector('#' + contentId + ' [data-summary-discount]');
      const mobileShip = document.querySelector('#' + contentId + ' [data-summary-shipping]');
      const mobileTot = document.querySelector('#' + contentId + ' [data-summary-total]');
      if (mobileSub) mobileSub.textContent = fmtMoney(cart.original_total_price, ccy);
      if (mobileDis) {
        const dis = Number(cart.total_discount || 0);
        mobileDis.textContent = dis > 0 ? '-' + fmtMoney(dis, ccy) : fmtMoney(0, ccy);
      }
      if (mobileShip) {
        if (ship === 0) {
          mobileShip.textContent = mobileShip.getAttribute('data-free-label') || 'FREE';
          mobileShip.classList.add('cart-summary__value--free');
        } else {
          mobileShip.textContent = '~' + fmtMoney(ship, ccy);
          mobileShip.classList.remove('cart-summary__value--free');
        }
      }
      if (mobileTot) mobileTot.textContent = fmtMoney(estimatedTotal, ccy);
    }

    function patchFromCartJs() {
      return fetch('/cart.js?_=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(r => r.json())
        .then(patchFromCart)
        .catch(() => {});
    }

    // Mobile accordion now lives inside this section, so we always refresh
    // the section HTML to rebuild the per-item / per-discount lists.
    let refreshTotalsTimer;
    function scheduleRefreshTotals() {
      clearTimeout(refreshTotalsTimer);
      refreshTotalsTimer = setTimeout(refreshTotals, 350);
    }

    // 有 event 內 cart 就同步改數字；section 重渲染僅桌面、且去抖避免連打
    function updateAll(eventCart) {
      if (eventCart && eventCart.items) {
        patchFromCart(eventCart);
      } else {
        patchFromCartJs();
      }
      scheduleRefreshTotals();
    }

    function cartFromEvent(ev) {
      if (!ev || !ev.detail) return null;
      return ev.detail.resource
        || (ev.detail.data && ev.detail.data.cart)
        || ev.detail.cart
        || null;
    }

    let lastEventAt = 0;
    document.addEventListener('cart:update', () => { lastEventAt = Date.now(); });
    document.addEventListener('cart:updated', () => { lastEventAt = Date.now(); });

    // —— A: 事件 —— //
    [
      'cart:update','cart:updated','cart:change','cart:refresh',
      'quantity:change','quantity-selector:update',
      'product:added','cart:item:added','cart:item:updated','cart:item:removed'
    ].forEach(evt => document.addEventListener(evt, (ev) => debounce(() => updateAll(cartFromEvent(ev)), 120)));

    // —— A2: 直接觀察 cart-items-component 的 DOM 變動（最可靠的「qty 改了」訊號）——
    function attachCartItemsObserver() {
      const cartItemsEl = document.querySelector('cart-items-component');
      if (!cartItemsEl || cartItemsEl.__cartTotalsObserved) return;
      cartItemsEl.__cartTotalsObserved = true;
      new MutationObserver(() => {
        if (Date.now() - lastEventAt < 900) return;
        debounce(() => updateAll(null), 150);
      }).observe(cartItemsEl, { childList: true, subtree: true, characterData: true });
    }
    attachCartItemsObserver();
    new MutationObserver(attachCartItemsObserver)
      .observe(document.body, { childList: true, subtree: true });

    // —— B: 攔截 cart 寫入請求。只比對「寫入」端點，避免 refreshTotals 自己的
    // /cart?sections= 與 /cart.js 又觸發自己造成無限迴圈。 ——
    // fetch 攔截僅作兜底（無 cart:update 事件的舊路徑）；事件路徑已帶 resource 可略過重複 /cart.js
    const isCartWrite = (u) => /\/cart\/(change|add|update|clear)(\.js)?(\?|$)/.test(String(u || ''));
    const _fetch = window.fetch;
    window.fetch = function(...args){
      return _fetch.apply(this, args).then(res => {
        try {
          if (isCartWrite(args[0]) && Date.now() - lastEventAt > 400) {
            debounce(() => updateAll(null), 150);
          }
        } catch(e){}
        return res;
      });
    };

    // 初始化先跑一次
    document.addEventListener('DOMContentLoaded', updateAll);
    updateAll();
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // NOTE: Shopify {% javascript %} blocks are concatenated raw into scripts.js
  // and do NOT process Liquid. Any {% ... %} literal here breaks the whole
  // bundle with "Unexpected token '%'", which silently kills ALL section JS
  // (including cart-totals quantity updates). The previous {% unless %} guard
  // for use_all_catalog_hub has been replaced with a pure JS guard.
  (function () {
    var url = new URL(window.location.href);
    if (!url.hash) return;
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        // On the All-Catalog hub page we skip auto-scroll to avoid hijacking
        // intra-page anchor navigation.
        if (document.querySelector('.apgo-all-catalog-root')) return;
        var card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
